import React, { PureComponent } from "react";

// Components
import "./style.css";

class ChurchAccessibility extends PureComponent {
    render() {
        const {
            parking,
            hcParking,
            toilet,
            hcToilet,
            wheelchairAccess,
            wheelchairSpots,
            functioningTeleloop,
            accessibilityInfoNorwegian,
        } = this.props.church;

        if (
            [
                parking,
                hcParking,
                toilet,
                hcToilet,
                wheelchairAccess,
                wheelchairSpots,
                functioningTeleloop,
            ].every((prop) => prop === undefined || prop === null)
        ) {
            return null;
        }

        return (
            <div className="church-facts__wrapper church-facts__wrapper--bluelight">
                <div className="church-facts__inner">
                    <h3 className="church-facts__title">Tilgjengelighet</h3>
                    {parking && (
                        <p>
                            <strong>Parkering: </strong>
                            {parking}
                        </p>
                    )}
                    {hcParking && (
                        <p>
                            <strong>HC-parkering: </strong>
                            {hcParking}
                        </p>
                    )}
                    {toilet && (
                        <p>
                            <strong>Toalett: </strong>
                            {toilet}
                        </p>
                    )}

                    {hcToilet && (
                        <p>
                            <strong>HC-toalett: </strong>
                            {hcToilet && hcToilet === "1"
                                ? "Ja"
                                : hcToilet && hcToilet === "0"
                                    ? "Nei"
                                    : hcToilet !== ""
                                        ? hcToilet
                                        : "Ukjent"}
                        </p>
                    )}

                    {wheelchairAccess && (
                        <p>
                            <strong>Rullestoladkomst: </strong>
                            {wheelchairAccess !== ""
                                ? wheelchairAccess
                                : "Ukjent"}
                        </p>
                    )}
                    {wheelchairSpots && (
                        <p>
                            <strong>Rullestolplass: </strong>
                            {wheelchairSpots !== ""
                                ? wheelchairSpots
                                : "Ukjent"}
                        </p>
                    )}
                    {functioningTeleloop && (
                        <p>
                            <strong>Teleslyngeanlegg: </strong>
                            {functioningTeleloop}
                        </p>
                    )}
                    {accessibilityInfoNorwegian && (
                        <p>
                            <strong>Informasjon om tilgjengelighet: </strong>
                            {accessibilityInfoNorwegian}
                        </p>
                    )}
                </div>
            </div>
        );
    }
}

export default ChurchAccessibility;



// WEBPACK FOOTER //
// ./src/components/ChurchAccessibility/index.js